// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wtv-error[data-v-525cf2fa]{padding:24px;position:relative;background-color:var(--color-bg);border-top:8px solid var(--color-second);display:flex;align-items:center;justify-content:center}.wtv-error[data-v-525cf2fa]:before{content:\"\\f071\";margin-right:10px;font-size:24px;width:32px;color:var(--color-second)}", ""]);
// Exports
module.exports = exports;
